<table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>
      {{ translationService.getEmailAddressText() }}
    </th>
    <td mat-cell *matCellDef="let user">{{ user.email }}</td>
  </ng-container>
  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef>
      {{ translationService.getRoleText() }}
    </th>
    <td mat-cell *matCellDef="let user">{{ user.role }}</td>
  </ng-container>
  <ng-container matColumnDef="company">
    <th mat-header-cell *matHeaderCellDef>
      {{ translationService.getCompanyText() }}
    </th>
    <td mat-cell *matCellDef="let user">{{ user.companyName }}</td>
  </ng-container>
  <ng-container matColumnDef="mfaEnabled">
    <th mat-header-cell *matHeaderCellDef>
      {{ translationService.getMfaText() }}
    </th>
    <td mat-cell *matCellDef="let user">
      <span
        class="toggle-mfa"
        (click)="toggleMfa(user)"
        [ngClass]="{ 'disabled-text': user.mfaEnabled }"
        (keydown.enter)="toggleMfa(user)"
        role="button"
        tabindex="0"
        [attr.aria-pressed]="user.mfaEnabled"
      >
        {{
          user.mfaEnabled
            ? translationService.getDisableText()
            : translationService.getEnableText()
        }}
      </span>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator
  showFirstLastButtons
  pageSize="10"
  hidePageSize="true"
></mat-paginator>
